/**
 *
 * Component: Input
 * Date: 22/10/2020
 *
 */

import React from 'react';

import { Input as CustomInput, InputNumber } from 'antd';
import styles from './style.module.css';

interface Props {
  height?: string;
  size?: string;
}

const Input = ({
  height = '43px',
  maxHeight = '59px',
  type = 'textarea',
  ...rest
}) => {
  const style = {
    height: height || '43px',
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '13px',
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    maxHeight: maxHeight || '59px',
    minHeight: height || '43px',
  };

  switch (type) {
    case 'textarea':
      return (
        <CustomInput.TextArea
          {...rest}
          className={styles.container}
          ref={rest.innerRef}
          style={{ ...style, height: 'auto' }}
        />
      );
    case 'input':
      return (
        <CustomInput
          {...rest}
          className={styles.container}
          ref={rest.innerRef}
          style={style}
        />
      );
    case 'password':
      return (
        <CustomInput.Password {...rest} ref={rest.innerRef} style={style} />
      );
    case 'number':
      return <InputNumber {...rest} ref={rest.innerRef} style={style} />;
    default:
      return <CustomInput {...rest} ref={rest.innerRef} style={style} />;
  }
};

export default Input;
